import React, { useState } from "react";
import { Botao, Box, CampoEstatico, Modal, TamanhoBotao, TipoCampoEstatico } from "@intechprev/componentes-web";
import { PrestacaoEntidade } from "../../../../entidades";

interface IProps {
  prestacoes: PrestacaoEntidade[];
}

export const Prestacoes: React.FC<IProps> = ({ prestacoes }) => {
  const [ModalAberto, setModalAberto] = useState<boolean>(false);
  const [Prestacao, setPrestacao] = useState<PrestacaoEntidade>(new PrestacaoEntidade());

  function ToMoney(Valor: number | undefined) {
    if (Valor == undefined) {
      return "0";
    }
    return (
      "R$ " +
      Valor.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  return (
    <>
      {prestacoes.length > 0 && (
        <Box titulo={"Prestações"}>
          <table className={"table table-striped table-sm"}>
            <thead>
              <tr>
                <th>Nº</th>
                <th>Vencimento</th>
                <th>Pagamento</th>
                <th>Prestação</th>
                <th>Recebido</th>
                <th>Saldo Devedor</th>
              </tr>
            </thead>
            <tbody>
              {prestacoes.map((prestacao: PrestacaoEntidade, index: number) => {
                if (prestacao.TIPO === "P") {
                  return (
                    <tr key={index}>
                      <td>{prestacao.PARCELA}</td>
                      <td>{prestacao.DT_VENC}</td>
                      <td>{prestacao.DT_PAGTO}</td>
                      <td>
                        <Botao
                          titulo={ToMoney(prestacao.VL_PRESTACAO!)}
                          tamanho={TamanhoBotao.mini}
                          onClick={() => {
                            setModalAberto(true);
                            setPrestacao(prestacao);
                          }}
                        />
                      </td>
                      <td>
                        <CampoEstatico
                          valor={prestacao.VL_RECEBIDO}
                          tipo={TipoCampoEstatico.dinheiro}
                        />
                      </td>
                      <td>
                        <CampoEstatico
                          valor={prestacao.VL_SALDO_ATUAL}
                          tipo={TipoCampoEstatico.dinheiro}
                        />
                      </td>
                    </tr>
                  );
                } else if (prestacao.TIPO === "S") {
                  return (
                    <tr key={index}>
                      <td></td>
                      <td>{prestacao.DT_VENC}</td>
                      <td colSpan={4}>Suspensa</td>
                    </tr>
                  );
                } else {
                  return (
                    <tr key={index}>
                      <td colSpan={6}></td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </table>
        </Box>
      )}

      <Modal
        onClose={() => setModalAberto(!ModalAberto)}
        onConfirm={() => setModalAberto(!ModalAberto)}
        visivel={ModalAberto}
        titulo={`Valor da Prestação: ${ToMoney(Prestacao.VL_PRESTACAO!)}`}
        tituloBotaoFechar={"OK, Entendi!"}
      >
        <CampoEstatico
          titulo={"Principal"}
          valor={Prestacao.VL_PRINCIPAL!}
          tipo={TipoCampoEstatico.dinheiro}
          tamanhoTitulo={"7"}
        />
        <CampoEstatico
          titulo={"Juros"}
          valor={Prestacao.VL_JUROS!}
          tipo={TipoCampoEstatico.dinheiro}
          tamanhoTitulo={"7"}
        />
        <CampoEstatico
          titulo={"Seguro"}
          valor={Prestacao.VL_TX_SEGURO!}
          tipo={TipoCampoEstatico.dinheiro}
          tamanhoTitulo={"7"}
        />
        <CampoEstatico
          titulo={"Taxa Inadimplência"}
          valor={Prestacao.VL_TX_INAD!}
          tipo={TipoCampoEstatico.dinheiro}
          tamanhoTitulo={"7"}
        />
        <CampoEstatico
          titulo={"Taxa Administração"}
          valor={Prestacao.VL_TX_ADM!}
          tipo={TipoCampoEstatico.dinheiro}
          tamanhoTitulo={"7"}
        />
        <CampoEstatico
          titulo={"Multa"}
          valor={Prestacao.VL_MULTA!}
          tipo={TipoCampoEstatico.dinheiro}
          tamanhoTitulo={"7"}
        />
        <CampoEstatico
          titulo={"Mora"}
          valor={Prestacao.VL_MORA!}
          tipo={TipoCampoEstatico.dinheiro}
          tamanhoTitulo={"7"}
        />
        <CampoEstatico
          titulo={"Desconto"}
          valor={Prestacao.VL_DESCONTO!}
          tipo={TipoCampoEstatico.dinheiro}
          tamanhoTitulo={"7"}
        />
      </Modal>
    </>
  );
}